ProductReviews = window.ProductReviews ?= {}
ProductReviews.Views ?= {}
ProductReviews.Views.Widget ?= {}
ProductReviews.Templates ?= {}

ProductReviews.Templates['product_reviews_widget_review_rating'] = require '../../widget_review_rating.html.mustache'

class ProductReviews.Views.Widget.Review
  constructor: ({@data, @uuid, @$el}) ->

  prepareData: ->
    return unless @data?.averageRating and @data.ratingCount

    rating = Math.round(@data.averageRating * 10) / 10
    bhc =
      rating: "deal-review-rating:#{@uuid}_#{rating}"
      ratingCount: "deal-rating-count:#{@uuid}_#{@data.ratingCount}"

    stars = []
    for position in [1..5]
      starType = switch
        when rating > 3/4
          'full-star'
        when rating > 1/4
          'half-star'
        else
          'empty-star'
      stars.push "<span class='#{starType} icon-star-filled'></span>"
      rating--

    productRating:
      bhc: bhc
      count: I18n.toNumber @data.ratingCount
      stars: stars

  render: ->
    @$el.find('.deal-title').after ProductReviews.Templates['product_reviews_widget_review_rating'].render(@prepareData())


module.exports = ProductReviews.Views.Widget.Review
